import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {_PRAIP_AKIRD} from '../../../equations/heartAttackBranch_Alberta(GeneralPopulation)/likelihoodOfAcuteKidneyInjuryRequiringDialysis/PRAIP_AKIRD'; // eslint-disable-line max-len
import {_PRACM_AKIRD} from '../../../equations/heartAttackBranch_Alberta(GeneralPopulation)/likelihoodOfAcuteKidneyInjuryRequiringDialysis/PRACM_AKIRD'; // eslint-disable-line max-len
import {_PRAIP_ESKF} from '../../../equations/heartAttackBranch_Alberta(GeneralPopulation)/likelihoodOfEndStageKidneyFailureWithInYear/PRAIP_ESKF'; // eslint-disable-line max-len
import {_PRACM_ESKF} from '../../../equations/heartAttackBranch_Alberta(GeneralPopulation)/likelihoodOfEndStageKidneyFailureWithInYear/PRACM_ESKF'; // eslint-disable-line max-len
import {_PRAIP_AKIRD as _PRAIP_AKIRD_BC} from '../../../equations/heartAttackBranch_BritishColumbia(Nephrology)/likelihoodOfAcuteKidneyInjuryRequiringDialysis/PRAIP_AKIRD'; // eslint-disable-line max-len
import {_PRACM_AKIRD as _PRACM_AKIRD_BC} from '../../../equations/heartAttackBranch_BritishColumbia(Nephrology)/likelihoodOfAcuteKidneyInjuryRequiringDialysis/PRACM_AKIRD'; // eslint-disable-line max-len
import {_PRAIP_ESKF as _PRAIP_ESKF_BC} from '../../../equations/heartAttackBranch_BritishColumbia(Nephrology)/likelihoodOfEndStageKidneyFailureWithInYear/PRAIP_ESKF'; // eslint-disable-line max-len
import {_PRACM_ESKF as _PRACM_ESKF_BC} from '../../../equations/heartAttackBranch_BritishColumbia(Nephrology)/likelihoodOfEndStageKidneyFailureWithInYear/PRACM_ESKF'; // eslint-disable-line max-len
import {Details as AcuteKidneyInjuryDetails} from './AcuteKidneyInjury/details';
import {References as AcuteKidneyInjuryReferences} from './AcuteKidneyInjury/references';
import {AdditionalInfo as AcuteKidneyInjuryAddInfo} from './AcuteKidneyInjury/additionalInfo';
import {Details as EndStageKidneyFailureDetails} from './EndStageKidneyFailure/details';
import {References as EndStageKidneyFailureReferences} from './EndStageKidneyFailure/references';
import {AdditionalInfo as EndStageKidneyFailureAddInfo} from './EndStageKidneyFailure/additionalInfo';
import risksInfo from '../../../../assets/images/icons/risks_info.svg';
import risksSymbol from '../../../../assets/images/icons/risks_symbol.svg';
import {Tooltip} from '../../common/tooltip';
import {GLOSSARY_KEYS, HEART_CONDITIONS} from '../../../containers/appConstants';
import {getFormattedResult} from '../../../utils/utils';

export const RisksDetails = () => {
  const healthFactors = useSelector(state => state.healthFactors);
  const dataSourceProvince = useSelector(state => state.heartCondition.dataSourceProvince);

  const [
    acuteKidneyInjuryDialysisInvasiveDetails,
    setAcuteKidneyInjuryDialysisInvasiveDetails] = useState({});
  const [
    acuteKidneyInjuryDialysisConservativeDetails,
    setAcuteKidneyInjuryDialysisConservativeDetails] = useState({});
  const [
    endStageKidneyFailureInvasiveDetails,
    setEndStageKidneyFailureInvasiveDetails] = useState({});
  const [
    endStageKidneyFailureConservativeDetails,
    setEndStageKidneyFailureConservativeDetails] = useState({});

  useEffect(() => {
    if (dataSourceProvince === HEART_CONDITIONS.BC_ONLY_PEOPLE_REFERRED_TO_A_NEPHROLOGIST) {
      setAcuteKidneyInjuryDialysisInvasiveDetails(_PRAIP_AKIRD_BC(healthFactors));
      setAcuteKidneyInjuryDialysisConservativeDetails(_PRACM_AKIRD_BC(healthFactors));
      setEndStageKidneyFailureInvasiveDetails(_PRAIP_ESKF_BC(healthFactors));
      setEndStageKidneyFailureConservativeDetails(_PRACM_ESKF_BC(healthFactors));
    }
    else {
      setAcuteKidneyInjuryDialysisInvasiveDetails(_PRAIP_AKIRD(healthFactors));
      setAcuteKidneyInjuryDialysisConservativeDetails(_PRACM_AKIRD(healthFactors));
      setEndStageKidneyFailureInvasiveDetails(_PRAIP_ESKF(healthFactors));
      setEndStageKidneyFailureConservativeDetails(_PRACM_ESKF(healthFactors));
    }
  }, []);

  return (
    <>
      <section className='bordered all-rounded-borders white-bg-color margin-bottom-2'>
        {
          process.env.REACT_APP_ENVIRONMENT !== 'production' &&
        <div className='grid-container'>
          <p>Values used in calculating these results (For testing only)</p>
          <table className='bordered margin-bottom-2 text-center'>
            <tr>
              <th className='bordered'>Field</th>
              <th className='bordered'>Value</th>
            </tr>
            <tr>
              <td className='bordered'>Age</td>
              <td className='bordered'>{acuteKidneyInjuryDialysisInvasiveDetails.age}</td>
            </tr>
            <tr>
              <td className='bordered'>Sex</td>
              <td className='bordered'>{acuteKidneyInjuryDialysisInvasiveDetails.sex}</td>
            </tr>
            <tr>
              <td className='bordered'>NSTEMI</td>
              <td className='bordered'>{acuteKidneyInjuryDialysisInvasiveDetails.nstemi}</td>
            </tr>
            <tr>
              <td className='bordered'>eGFR</td>
              <td className='bordered'>{acuteKidneyInjuryDialysisInvasiveDetails.eGFR}</td>
            </tr>
            <tr>
              <td className='bordered'>Hemoglobin</td>
              <td className='bordered'>{acuteKidneyInjuryDialysisInvasiveDetails.haemoglobin}</td>
            </tr>
            <tr>
              <td className='bordered'>Albuminuria Mild</td>
              <td className='bordered'>{acuteKidneyInjuryDialysisInvasiveDetails.albuminuria_mild}</td>
            </tr>
            <tr>
              <td className='bordered'>Albuminuria Heavy</td>
              <td className='bordered'>{acuteKidneyInjuryDialysisInvasiveDetails.albuminuria_heavy}</td>
            </tr>
            <tr>
              <td className='bordered'>Diabetes</td>
              <td className='bordered'>{acuteKidneyInjuryDialysisInvasiveDetails.diabetes}</td>
            </tr>
            <tr>
              <td className='bordered'>Prior Invasive</td>
              <td className='bordered'>{acuteKidneyInjuryDialysisInvasiveDetails.prior_invasive}</td>
            </tr>
            <tr>
              <td className='bordered'>AEBX (Used In Equation)</td>
              <td className='bordered'>{acuteKidneyInjuryDialysisInvasiveDetails.AEBX}</td>
            </tr>
            <tr>
              <td className='bordered'>Predicted Risk Invasive</td>
              <td className='bordered'>{acuteKidneyInjuryDialysisInvasiveDetails.PRI}</td>
            </tr>
            <tr>
              <td className='bordered'>Probability (Predicted Risk Invasive x 100)</td>
              <td className='bordered'>{acuteKidneyInjuryDialysisInvasiveDetails.probability}</td>
            </tr>
            <tr>
              <td className='bordered'>Conservative Management</td>
              <td className='bordered'>{acuteKidneyInjuryDialysisConservativeDetails.PRC}</td>
            </tr>
            <tr>
              <td className='bordered'>Probability (Conservative Management x 100)</td>
              <td className='bordered'>{acuteKidneyInjuryDialysisConservativeDetails.probability}</td>
            </tr>
          </table>
        </div>
        }
        <div className='grid-container'>
          <div className='text-center'>
            <h2>Likelihood of an acute kidney injury treated with short-term dialysis</h2>
            <div className='grid-x medium-up-2 margin-vertical-1'>
              <div className='cell'>
                <div className='card align-center border-right'>
                  <h4 className='margin-bottom-1 height-50-px'>
                    Invasive Heart Procedure plus<br/> Optimal Medication Management
                  </h4>
                  <div className='rounded percentage-circle bg-color-red margin-vertical-1'>
                    <div className='rounded inside-circle'>
                      <img
                        alt='Icon image'
                        src={risksSymbol}/>
                      <p className='margin-0'>
                        {getFormattedResult(Number(acuteKidneyInjuryDialysisInvasiveDetails.PRI * 100).toFixed(0))}%
                      </p>
                    </div>
                  </div>
                  <p>
                    ({getFormattedResult(Number(acuteKidneyInjuryDialysisInvasiveDetails.PRI * 100).toFixed(0))}/100)
                  </p>
                </div>
              </div>
              <div className='cell '>
                <div className='card align-center'>
                  <h4 className='margin-bottom-1 height-50-px'>
                    Optimal Medication Management
                  </h4>
                  <div className='rounded percentage-circle bg-color-red margin-vertical-1'>
                    <div className='rounded inside-circle'>
                      <img
                        alt='Icon image'
                        src={risksSymbol}/>
                      <p className='margin-0'>
                        {getFormattedResult(Number(acuteKidneyInjuryDialysisConservativeDetails.PRC * 100).toFixed(0))}%
                      </p>
                    </div>
                  </div>
                  <p>
                    ({getFormattedResult(Number(acuteKidneyInjuryDialysisConservativeDetails.PRC * 100).toFixed(0))}/100)
                  </p>
                </div>
              </div>
            </div>
            <div className='grid-x align-center-middle'>
              <div className='cell shrink margin-0'>
                <img
                  alt='Icon image'
                  className='margin-right-1'
                  src={risksInfo}/>
              </div>
              <div className='cell auto margin-0 text-left'>
                {
                  Number(acuteKidneyInjuryDialysisInvasiveDetails.PRI * 100).toFixed(0) -
                  Number(acuteKidneyInjuryDialysisConservativeDetails.PRC * 100).toFixed(0) === 0
                    ? <p className='margin-0'>
                      Treatment with an&nbsp;<Tooltip
                        id={GLOSSARY_KEYS.INVASIVE_HEART_PROCEDURE}
                        title='invasive heart procedure'/>&nbsp;caused&nbsp;<span className='risks-text'>no additional
                      acute kidney injuries treated with short-term dialysis for every 100 patients</span>&nbsp;like
                      you.
                    </p>
                    : <p className='margin-0'>
                      Treatment with an&nbsp;<Tooltip
                        id={GLOSSARY_KEYS.INVASIVE_HEART_PROCEDURE}
                        title='invasive heart procedure'/>&nbsp;caused&nbsp;<span className='risks-text'>{
                        Number(acuteKidneyInjuryDialysisInvasiveDetails.PRI * 100).toFixed(0) -
                      Number(acuteKidneyInjuryDialysisConservativeDetails.PRC * 100).toFixed(0)
                      } additional acute kidney injuries treated with short-term dialysis for every 100
                      patients</span>&nbsp;like you compared to optimal medication management.
                    </p>
                }
              </div>
            </div>
            {/* The below section is only visible on screen, not while printing */}
            <div className='grid-x text-left margin-vertical-1 hide-for-print'>
              <div className='cell bordered all-rounded-borders'>
                <details>
                  <summary className='padding-2'>
                    <h3 className='info-color text-uppercase'>What does this look like?</h3>
                  </summary>
                  <AcuteKidneyInjuryDetails
                    conservativeProb={Number(acuteKidneyInjuryDialysisConservativeDetails.PRC * 100).toFixed(0)}
                    invasiveProb={Number(acuteKidneyInjuryDialysisInvasiveDetails.PRI * 100).toFixed(0)}
                  />
                </details>
              </div>
            </div>
            {/* The below section is only visible while printing */}
            <div className='margin-vertical-2 padding-vertical-2 show-for-print bordered all-rounded-borders text-left'>
              <AcuteKidneyInjuryDetails
                conservativeProb={Number(acuteKidneyInjuryDialysisConservativeDetails.PRC * 100).toFixed(0)}
                invasiveProb={Number(acuteKidneyInjuryDialysisInvasiveDetails.PRI * 100).toFixed(0)}
              />
              <div className='padding-horizontal-2'>
                <AcuteKidneyInjuryAddInfo/>
              </div>
            </div>
            {/* The below section is only visible on screen */}
            <div className='grid-x text-left margin-vertical-1 hide-for-print'>
              <div className='cell bordered all-rounded-borders'>
                <details>
                  <summary className='padding-2'>
                    <h3 className='info-color text-uppercase'>
                      What is this information based on? (Show me the references)
                    </h3>
                  </summary>
                  <AcuteKidneyInjuryReferences/>
                </details>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='bordered all-rounded-borders white-bg-color margin-bottom-2'>
        {
          process.env.REACT_APP_ENVIRONMENT !== 'production' &&
        <div className='grid-container'>
          <p>Values used in calculating these results (For testing only)</p>
          <table className='bordered margin-bottom-2 text-center'>
            <tr>
              <th className='bordered'>Field</th>
              <th className='bordered'>Value</th>
            </tr>
            <tr>
              <td className='bordered'>Age</td>
              <td className='bordered'>{endStageKidneyFailureInvasiveDetails.age}</td>
            </tr>
            <tr>
              <td className='bordered'>Sex</td>
              <td className='bordered'>{endStageKidneyFailureInvasiveDetails.sex}</td>
            </tr>
            <tr>
              <td className='bordered'>eGFR</td>
              <td className='bordered'>{endStageKidneyFailureInvasiveDetails.eGFR}</td>
            </tr>
            <tr>
              <td className='bordered'>Hemoglobin</td>
              <td className='bordered'>{endStageKidneyFailureInvasiveDetails.haemoglobin}</td>
            </tr>
            <tr>
              <td className='bordered'>Albuminuria Mild</td>
              <td className='bordered'>{endStageKidneyFailureInvasiveDetails.albuminuria_mild}</td>
            </tr>
            <tr>
              <td className='bordered'>Albuminuria Heavy</td>
              <td className='bordered'>{endStageKidneyFailureInvasiveDetails.albuminuria_heavy}</td>
            </tr>
            <tr>
              <td className='bordered'>Prior Invasive</td>
              <td className='bordered'>{endStageKidneyFailureInvasiveDetails.prior_invasive}</td>
            </tr>
            <tr>
              <td className='bordered'>S0 (Used In Equation)</td>
              <td className='bordered'>{endStageKidneyFailureInvasiveDetails.S0}</td>
            </tr>
            <tr>
              <td className='bordered'>EBX (Used In Equation)</td>
              <td className='bordered'>{endStageKidneyFailureInvasiveDetails.EBX}</td>
            </tr>
            <tr>
              <td className='bordered'>Predicted Risk Invasive</td>
              <td className='bordered'>{endStageKidneyFailureInvasiveDetails.PRI}</td>
            </tr>
            <tr>
              <td className='bordered'>Probability (Predicted Risk Invasive x 100)</td>
              <td className='bordered'>{endStageKidneyFailureInvasiveDetails.probability}</td>
            </tr>
            <tr>
              <td className='bordered'>Conservative Management</td>
              <td className='bordered'>{endStageKidneyFailureConservativeDetails.PRC}</td>
            </tr>
            <tr>
              <td className='bordered'>Probability (Conservative Management x 100)</td>
              <td className='bordered'>{endStageKidneyFailureConservativeDetails.probability}</td>
            </tr>
          </table>
        </div>
        }
        <div className='grid-container'>
          <div className='text-center'>
            <h2>Likelihood of End Stage Kidney Failure within one year</h2>
            <div className='grid-x medium-up-2 margin-vertical-1'>
              <div className='cell'>
                <div className='card align-center border-right'>
                  <h4 className='margin-bottom-1 height-50-px'>
                    Invasive Heart Procedure plus<br/> Optimal Medication Management
                  </h4>
                  <div className='rounded percentage-circle bg-color-red margin-vertical-1'>
                    <div className='rounded inside-circle'>
                      <img
                        alt='Icon image'
                        src={risksSymbol}/>
                      <p className='margin-0'>
                        {getFormattedResult(Number(endStageKidneyFailureInvasiveDetails.PRI * 100).toFixed(0))}%
                      </p>
                    </div>
                  </div>
                  <p>
                    ({getFormattedResult(Number(endStageKidneyFailureInvasiveDetails.PRI * 100).toFixed(0))}/100)
                  </p>
                </div>
              </div>
              <div className='cell '>
                <div className='card align-center'>
                  <h4 className='margin-bottom-1 height-50-px'>
                    Optimal Medication Management
                  </h4>
                  <div className='rounded percentage-circle bg-color-red margin-vertical-1'>
                    <div className='rounded inside-circle'>
                      <img
                        alt='Icon image'
                        src={risksSymbol}/>
                      <p className='margin-0'>
                        {getFormattedResult(Number(endStageKidneyFailureConservativeDetails.PRC * 100).toFixed(0))}%
                      </p>
                    </div>
                  </div>
                  <p>
                    ({getFormattedResult(Number(endStageKidneyFailureConservativeDetails.PRC * 100).toFixed(0))}/100)
                  </p>
                </div>
              </div>
            </div>
            <div className='grid-x align-center-middle'>
              <div className='cell shrink margin-0'>
                <img
                  alt='Icon image'
                  className='margin-right-1'
                  src={risksInfo}/>
              </div>
              <div className='cell auto margin-0 text-left'>
                {
                  Number(endStageKidneyFailureInvasiveDetails.PRI * 100).toFixed(0) -
                  Number(endStageKidneyFailureConservativeDetails.PRC * 100).toFixed(0) === 0
                    ? <p className='margin-0'>
                      Treatment with an&nbsp;<Tooltip
                        id={GLOSSARY_KEYS.INVASIVE_HEART_PROCEDURE}
                        title='invasive heart procedure'/>&nbsp;caused&nbsp;<span className='risks-text'>no additional
                      end-stage kidney failures for every 100 patients</span>&nbsp;like you.
                    </p>
                    : <p className='margin-0'>
                      Treatment with an&nbsp;<Tooltip
                        id={GLOSSARY_KEYS.INVASIVE_HEART_PROCEDURE}
                        title='invasive heart procedure'/>&nbsp;caused&nbsp;<span className='risks-text'>
                        {
                          Number(endStageKidneyFailureInvasiveDetails.PRI * 100).toFixed(0) -
                          Number(endStageKidneyFailureConservativeDetails.PRC * 100).toFixed(0)
                        } additional end-stage kidney failures for every 100 patients</span>&nbsp;like you compared
                      to&nbsp;
                      <Tooltip
                        id={GLOSSARY_KEYS.OPTIMAL_MEDICATION_MANAGEMENT}
                        title='optimal medication management'/>.
                    </p>
                }
              </div>
            </div>
            {/* The below section is only visible on screen, not while printing */}
            <div className='grid-x text-left margin-vertical-1 hide-for-print'>
              <div className='cell bordered all-rounded-borders'>
                <details>
                  <summary className='padding-2'>
                    <h3 className='info-color text-uppercase'>What does this look like?</h3>
                  </summary>
                  <EndStageKidneyFailureDetails
                    conservativeProb={Number(endStageKidneyFailureConservativeDetails.PRC * 100).toFixed(0)}
                    invasiveProb={Number(endStageKidneyFailureInvasiveDetails.PRI * 100).toFixed(0)}
                  />
                </details>
              </div>
            </div>
            {/* The below section is only visible while printing */}
            <div className='margin-vertical-2 padding-vertical-2 show-for-print bordered all-rounded-borders text-left'>
              <EndStageKidneyFailureDetails
                conservativeProb={Number(endStageKidneyFailureConservativeDetails.PRC * 100).toFixed(0)}
                invasiveProb={Number(endStageKidneyFailureInvasiveDetails.PRI * 100).toFixed(0)}
              />
              <div className='padding-horizontal-2'>
                <EndStageKidneyFailureAddInfo/>
              </div>
            </div>
            {/* The below section is only visible on screen */}
            <div className='grid-x text-left margin-vertical-1 hide-for-print'>
              <div className='cell bordered all-rounded-borders'>
                <details>
                  <summary className='padding-2'>
                    <h3 className='info-color text-uppercase'>
                      What is this information based on? (Show me the references)
                    </h3>
                  </summary>
                  <EndStageKidneyFailureReferences/>
                </details>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
